const mqttData = (state) => (macAddr) => {
  if (!state.data[macAddr]) return [];
  return state.data[macAddr];
};

const mqttPortData = (state) => (macAddr, portName) => {
  if (!state.data[macAddr]) return [];
  return state.data[macAddr].reduce((results, ports) => {
    const portValue = ports[portName];
    if (portValue == null) return results;
    if (portName !== 'ts' && ports.ts) {
      results.push({ ...portValue, ts: ports.ts });
    } else {
      results.push(portValue);
    }
    return results;
  }, []);
};

const mqttSlaveData = (state) => (macAddr, portIdDec) => {
  if (!macAddr || !portIdDec) return [];

  const portIdKey = portIdDec.toString();

  if (!state.data[portIdKey]) return [];

  return state.data[portIdKey];
};

const mqttState = (state) => (uid) => {
  if (process.env.NODE_ENV !== 'production') return true;

  const client = state.clientList.find(
    (el) => el.dev_id === uid || el.mac_addr === uid
  );
  return client && state.conn[client.mac_addr] && state.connState;
};

const mqttLoading = (state) => (uid) => {
  return state.mqttLoading[uid];
};

const logDownloadLink = (state) => (uid) => {
  const client = state.clientList.find(
    (el) => el.dev_id === uid || el.mac_addr === uid
  );
  return client ? state.log[client.mac_addr] : null;
};

const updatedQueueList = (state) => state.updatedList;

const configState = (state) => (uid, isUpdatingFW) =>
  state.configQueue.filter(
    (l) => l.dev_id === uid && (!isUpdatingFW || l.device_pkgware)
  ).length;

const mqttConnectionState = (state) => state.connState;

const mqttClient = (state) => state.mqttClient;

const alarmState = (state) => (params) => {
  const { mac_addr, port_name, port_id, event_id } = params || {};
  return state.alarmState.filter(
    (alarm) =>
      (alarm.mac_addr === mac_addr || mac_addr == null) &&
      (alarm.port_name === port_name || port_name == null) &&
      (alarm.port_id === port_id || port_id == null) &&
      (alarm.event_id === event_id || event_id == null)
  );
};

const clientList = (state) => state.clientList;

export default {
  mqttData,
  mqttSlaveData,
  mqttClient,
  mqttState,
  mqttLoading,
  mqttPortData,
  mqttConnectionState,
  configState,
  updatedQueueList,
  alarmState,
  clientList,
  logDownloadLink,
};
